
import Vue from 'vue'
import algoliasearch from 'algoliasearch/lite'
import {
   AisInstantSearch,
   AisSearchBox,
   AisHits,
   AisStateResults,
   AisConfigure,
} from 'vue-instantsearch'

export default Vue.extend({
   name: 'SchoolSearchFormGroup',
   props: {
      id: String,
      label: String,
      value: String,
      placeholder: { type: String, default: 'Start typing to search for your school' },
      instructions: { type: String, default: '' },
   },
   data() {
      return {
         searchText: '',
         searchResult: '',
         searching: false,
         searchClient: algoliasearch(
            this.$store.state.modelData.AlgoliaAppId,
            this.$store.state.modelData.AlgoliaApiKey
         ),
      }
   },
   computed: {
      algoliaIndex(): string {
         return this.$store.state.modelData.AlgoliaIndex
      },
   },
   methods: {
      selectSchool(school: { objectID: string; name: string; address: string }) {
         if (school && school.objectID) {
            this.$emit('input', {
               Id: school.objectID,
               Name: school.name,
               AddressSummary: school.address,
            })
         } else {
            this.$emit('attempt')
         }
      },
   },
   components: { AisInstantSearch, AisSearchBox, AisHits, AisStateResults, AisConfigure },
})
